<div style="display:flex; flex-direction: column;">
    <div *ngIf="isLoggedIn && isPageLoaded" style="height:53px;">
        <div  style="position:absolute;top:0px;left:0px;height:53px;">
            <table style="height:100%">
                <tr>
                    <td>
                        <button class="sis-header-menu" [ngClass]="{'hideHamburgerMenu': !showMenuButton()}"
                            [attr.title]="'Menu' | translate" (click)="toggleClick()"></button>
                    </td>
                    <td>
                        <button class="sis-header-home" [attr.title]="'Home' | translate" (click)="homeClick()"
                            *ngIf="!LoginSettings.V10"></button>
                        <button class="sis-header-home" [attr.title]="'Home' | translate" *ngIf="LoginSettings.V10"
                            [routerLink]="userService.userType == '1' && LoginSettings.ActivateClassroom360 ? 'classroom360/cards' : 'student360/studentSummary'"></button>
                    </td>
                    <td *ngIf="router.url != '/admin360/globalSearch'">
                        <div class="sis-app-tylersis-title" style="text-align:left;">Tyler SIS</div>
                    </td>
                    <td *ngIf="impersonateByUserId > 0 && router.url != '/admin360/globalSearch'">
                        <div [ngClass]="{'sis-header-impersonateduser-title': impersonateByUserId > 0}">
                            Impersonating <br />
                            {{currentUser.FirstName}} {{currentUser.LastName}}
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div style="position:absolute;top:0px;right:0px;height:53px;">
            <table style="height:100%; ">
                <tr>
                    <td *ngIf="userService.userType == '1' && LoginSettings.ActivateClassroom360 && router.url != '/admin360/globalSearch'"
                        class="headerControls">
                        <div *ngIf="windowWidth >= 1024">
                            <img src="./assets/images/topbarschool.png" [attr.title]="'School' | translate"
                                *ngIf="showSchoolDropdown==true" />
                            <img src="./assets/images/topbarschool.png" [attr.title]="'School' | translate"
                                *ngIf="showSchoolDropdown==false" />
                            <tyl-form-field class="tyl-mat-dropdown" style="padding-left:5px; padding-right:10px;">
                                <mat-select [(ngModel)]="selectedSchoolId"
                                    (selectionChange)="schoolSelected(selectedSchoolId)"
                                    [ngStyle]="{'background-color': showSchoolDropdown ? 'white': ''}"
                                    [disabled]="showSchoolDropdown==false" id="ddlSchoolSelection">
                                    <mat-option *ngFor="let school of schools" [value]="school.Id">
                                        <span *ngIf="!LoginSettings.V10">{{school.SchoolCode}} - </span>
                                        {{school.SchoolName}}
                                    </mat-option>
                                </mat-select>
                            </tyl-form-field>
                        </div>
                        <div *ngIf="windowWidth < 1024">
                            <button class="sis-header-school" [attr.title]="'School' | translate"
                                [matMenuTriggerFor]="schoolMenu.menu"></button>
                            <tyl-general-mat-menu #schoolMenu="menuTrigger">
                                <button mat-menu-item *ngFor="let school of schools"
                                    (click)="schoolSelected(school.Id)">
                                    <span *ngIf="!LoginSettings.V10">{{school.SchoolCode}} - </span>
                                    {{school.SchoolName}}
                                </button>
                            </tyl-general-mat-menu>
                        </div>
                    </td>
                    <td *ngIf="currentUser.UserType == '1' && LoginSettings.ActivateClassroom360 && router.url != '/admin360/globalSearch'"
                        class="headerControls">
                        <div *ngIf="windowWidth >= 1024 && showYearDropdown==true">
                            <img src="./assets/images/topbaryear.png" [attr.title]="'Year' | translate"
                                [ngStyle]="{'padding-right': showYearDropdown==false? '10px': '0px'}" />
                            <tyl-form-field class="tyl-mat-dropdown" style="padding-left:5px; padding-right:10px;"
                                [ngClass]="{'year-dropdown-past': !disableYearDropdown && selectedYear.Status==0, 'year-dropdown-future': !disableYearDropdown && selectedYear.Status==2}">
                                <mat-select [(ngModel)]="selectedYear" (selectionChange)="yearSelected(selectedYear)"
                                    [disabled]="disableYearDropdown" id="ddlAcademicYearSelection">
                                    <mat-option *ngFor="let year of years" [value]="year">
                                        <div>
                                            <div style="width:10px;height:10px;display:inline-block;">
                                                <div style="width:10px;height:10px;" *ngIf="year.Status != 1"
                                                    [ngStyle]="{'background-color': year.Status==0 ? '#ff80ab': '#00e676'}">
                                                </div>
                                            </div>
                                            <span style="padding-left:5px;">{{year.Description}}</span>
                                            <span *ngIf="year.Status != 1 ">
                                                {{(year.Status==0 && year.IsOverride == false) ? ' (past)' : (year.Status==0 && year.IsOverride == true) ? ' (past*)' : (year.Status == 2 && year.IsOverride == true) ? ' (future*)' : ' (future)'}}
                                            </span>
                                            <span *ngIf="year.Status == 1 && year.IsOverride == true">
                                                {{year.Status==1 ? ' (current*)' : ' '}}
                                            </span>
                                        </div>
                                    </mat-option>
                                </mat-select>
                            </tyl-form-field>
                        </div>
                        <div *ngIf="windowWidth < 1024">
                            <button class="sis-header-year" [attr.title]="'Year' | translate"
                                [matMenuTriggerFor]="yearMenu.menu"
                                [class.sis-header-year-past]="selectedYear.Status==0"
                                [class.sis-header-year-future]="selectedYear.Status==2"></button>
                            <tyl-general-mat-menu #yearMenu="menuTrigger">
                                <button mat-menu-item *ngFor="let year of years" (click)="yearSelected(year)">
                                    <div>
                                        <div style="width:10px;height:10px;display:inline-block;">
                                            <div style="width:10px;height:10px;" *ngIf="year.Status != 1"
                                                [ngStyle]="{'background-color': year.Status==0 ? '#ff80ab': '#00e676'}">
                                            </div>
                                        </div>
                                        <span style="padding-left:5px;">{{year.Description}}</span>
                                        <span
                                            *ngIf="year.Status != 1">{{year.Status==0 ? " (past)": " (future)"}}</span>
                                    </div>
                                </button>
                            </tyl-general-mat-menu>
                        </div>
                    </td>
                    <td
                        *ngIf="currentUser.UserType == '1' && currentUser.UserIsTeacher && LoginSettings.ActivateClassroom360 && router.url != '/admin360/globalSearch'">
                        <img src="./assets/images/topbarclassdisabled.png" [attr.title]="'Class' | translate"
                            [ngStyle]="{'padding-right': !enableClassDropdown ? '10px': '0px'}"
                            *ngIf="!enableClassDropdown" />
                        <div *ngIf="enableClassDropdown">
                            <button class="sis-header-course" [attr.title]="'Class' | translate"
                                [matMenuTriggerFor]="classMenu.menu" *ngIf="courseCategory('general')"></button>
                            <tyl-general-mat-menu #classMenu="menuTrigger">
                                <button mat-menu-item *ngFor="let class of myClasses"
                                    (click)="courseSelected(class)">{{class.CourseMenuText}}</button>
                            </tyl-general-mat-menu>

                            <button class="sis-header-course" [attr.title]="'Class' | translate"
                                [matMenuTriggerFor]="gbClassMenu.menu" *ngIf="courseCategory('gradebook')"></button>
                            <tyl-general-mat-menu #gbClassMenu="menuTrigger">
                                <button mat-menu-item *ngFor="let class of gradebookClasses"
                                    (click)="courseSelected(class)">{{class.CourseMenuText}}</button>
                            </tyl-general-mat-menu>

                            <button class="sis-header-course" [attr.title]="'Class' | translate"
                                [matMenuTriggerFor]="attClassMenu.menu" *ngIf="courseCategory('attendance')"></button>
                            <tyl-general-mat-menu #attClassMenu="menuTrigger">
                                <button mat-menu-item *ngFor="let class of attendanceClasses"
                                    (click)="courseSelected(class)">{{class.CourseMenuText}}</button>
                            </tyl-general-mat-menu>
                        </div>
                    </td>

                    <!-- Student Search -->
                    <td style="padding-right:5px;"
                        *ngIf="currentUser.UserType == '1' && router.url != '/admin360/globalSearch'">
                        <button class="sis-header-student" [attr.title]="'Search Student' | translate"
                            (click)="studentSearchClick('')"></button>
                    </td>

                    <!-- Student in Focus -->
                    <td style="padding-right:5px;"
                        *ngIf="currentUser.UserType == '1' && LoginSettings.ActivateClassroom360 && router.url != '/admin360/globalSearch'">
                        <tyl-button [image]="studentInFocus() ? 'focusamber.png' : 'focusdisabled.png'"
                            [attr.title]="'Student in Focus' | translate" (clickEvent)="studentInFocusClick()">
                        </tyl-button>
                    </td>

                    <td style="padding-top:5px;"
                        *ngIf="currentUser.UserType == '1' && (showGALDS || showAZEds || (LoginSettings.EnablePulseSSO && LoginSettings.ActivateClassroom360)) && router.url != '/admin360/globalSearch'">
                        <div style="height:35px;border-right:1px solid #9fa8da;display:inline-block;"></div>
                    </td>

                    <!-- GALDS SSO -->
                    <td *ngIf="showGALDS && router.url != '/admin360/globalSearch'">
                        <tyl-button image="topbarglads.png" [attr.title]="GALDS | translate"
                            (clickEvent)="galdsClick()"></tyl-button>
                    </td>

                    <!-- AZEds SSO -->
                    <td *ngIf="showAZEds && router.url != '/admin360/globalSearch'">
                        <tyl-button image="topbararizona.png" [attr.title]="Arizona | translate"
                            (clickEvent)="AZEdsClick()"></tyl-button>
                    </td>

                    <!-- Pulse -->
                    <td style="padding-top:5px;"
                        *ngIf="currentUser.UserType == '1' && LoginSettings.EnablePulseSSO && LoginSettings.ActivateClassroom360 && router.url != '/admin360/globalSearch'">
                        <button class="sis-header-pulse" [attr.title]="'Pulse' | translate"
                            [matMenuTriggerFor]="pulseMenu"></button>
                        <mat-menu #pulseMenu="matMenu">
                            <button mat-menu-item (click)="pulseLinkClick('Home')">Home</button>
                            <button *ngFor="let link of pulsePageList" mat-menu-item
                                (click)="pulseLinkClick(link.Shortcut)">
                                {{link.Name}}
                            </button>
                            <button mat-menu-item [matMenuTriggerFor]="favoritesMenu">
                                Favorites
                            </button>
                        </mat-menu>
                        <mat-menu #favoritesMenu="matMenu">
                            <button *ngFor="let link of pulseFavoriteList" mat-menu-item
                                (click)="pulseLinkClick(link.Shortcut)">
                                {{link.Name}}
                            </button>
                        </mat-menu>
                    </td>
                    <td style="padding-top:5px;"
                        *ngIf="currentUser.UserType == '1' && router.url != '/admin360/globalSearch'">
                        <div style="height:35px;border-left:1px solid #9fa8da;display:inline-block;" *ngIf="1==0">
                            <table>
                                <tr>
                                    <td>
                                        <button class="sis-header-galds" [attr.title]="'GALDS' | translate"
                                            (click)="openReportsWindow()"></button>
                                    </td>
                                    <td>
                                        <button class="sis-header-arizona" [attr.title]="'SAIS' | translate"
                                            (click)="openReportsWindow()"></button>
                                    </td>
                                    <td>
                                        <button class="sis-header-pulse" [attr.title]="'Tyler Pulse' | translate"
                                            (click)="openReportsWindow()"></button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div style="height:35px;border-right:1px solid #9fa8da;display:inline-block;"></div>
                    </td>
                    <td
                        *ngIf="currentUser.UserType == '1' && LoginSettings.ActivateClassroom360 && router.url != '/admin360/globalSearch'">
                        <button class="sis-header-reports" [attr.title]="'Reports' | translate"
                            (click)="openReportsWindow()"></button>
                    </td>
                    <td
                        *ngIf="currentUser.UserType == '1' && LoginSettings.ActivateClassroom360 && router.url != '/admin360/globalSearch'">
                        <button class="sis-header-favorites" [attr.title]="'Favorites' | translate"
                            [matMenuTriggerFor]="favoritesMenu.menu"></button>
                        <tyl-general-mat-menu #favoritesMenu="menuTrigger">
                            <div style="display: flex; flex-direction: row;">
                                <div mat-menu-item (click)="addFavoriteClick()" role="button" tabindex="0">
                                    <span style="margin-right: 20px;">
                                        <img alt="Add Link" src="./assets/images/add.png"
                                            [attr.title]="'Add Link' | translate"
                                            style="width:25px; margin-right: 5px">Add
                                        Current Page
                                    </span>
                                </div>
                                <div mat-menu-item (click)="editFavoriteClick();" role="button" tabindex="0">
                                    <span>
                                        <img alt="Edit Link" src="./assets/images/edit.png"
                                            [attr.title]="'Edit Link' | translate"
                                            style="width:25px; margin-right: 5px">Edit
                                        Favorites
                                    </span>
                                </div>
                            </div>

                            <menu favoritesFilter="true"></menu>

                        </tyl-general-mat-menu>
                    </td>
                    <td *ngIf="router.url != '/admin360/globalSearch'">
                        <button class="sis-header-links" (click)="linksClick()" [attr.title]="'Links' | translate"
                            [matMenuTriggerFor]="linksMenu.menu"></button>
                        <tyl-general-mat-menu #linksMenu="menuTrigger">
                            <div mat-menu-item *ngIf="userService.userType == 1 && addEditLinkPrivilege()">
                                <span *ngIf="userService.userType == 1" (click)="addLinkClick()" role="button"
                                    tabindex="0" style="margin-right: 20px;">
                                    <img alt="Add Link" src="./assets/images/add.png"
                                        [attr.title]="'Add Link' | translate" style="width:25px; margin-right: 5px">Add
                                    Link
                                </span>
                                <span *ngIf="userService.userType == 1" (click)="editLinkClick()" role="button"
                                    tabindex="0">
                                    <img alt="Edit Links" src="./assets/images/edit.png"
                                        [attr.title]="'Edit Link' | translate"
                                        style="width:25px; margin-right: 5px">Edit
                                    Links
                                </span>
                            </div>
                            <button mat-menu-item *ngFor="let link of districtLinks"
                                (click)="linkSelected(link)">{{link.LinkName}}</button>
                            <div *ngIf="userService.userType == 1"
                                style="border-bottom-style: solid;border-bottom-width: 1px;height: 1px;border-bottom-color: rgba(0,0,0,.2);">
                            </div>
                            <button mat-menu-item *ngFor="let link of myLinks"
                                (click)="linkSelected(link)">{{link.LinkName}}</button>
                        </tyl-general-mat-menu>
                    </td>
                    <td style="padding-left:10px;padding-right:10px;" *ngIf="router.url != '/admin360/globalSearch'"
                        ng-show="!hidePrint">
                        <div style="margin-top:2px;" (click)="!disabledPrint && printClick()">
                            <button [attr.title]="'Print Page' | translate" class="sis-header-print"
                                ng-disabled="disabledPrint"></button>
                        </div>
                    </td>
                    <td>
                        <div *ngIf="currentUser.UserType == '1' && LoginSettings.ActivateClassroom360 ">
                            <button class="sis-header-help" [attr.title]="'Help' | translate"
                                [matMenuTriggerFor]="helpMenu.menu"></button>
                            <tyl-general-mat-menu #helpMenu="menuTrigger">
                                <button mat-menu-item (click)="aboutTylerSISClick()">About Tyler SIS</button>
                                <button mat-menu-item (click)="documentationClick()">Documentation</button>
                                <button mat-menu-item (click)="trainingClick()" *ngIf="!V10">Training</button>
                            </tyl-general-mat-menu>
                        </div>
                        <div *ngIf="currentUser.UserType != '1' || !LoginSettings.ActivateClassroom360">
                            <button class="sis-header-help" [attr.title]="'Help' | translate"
                                (click)="helpClick()"></button>
                        </div>
                    </td>
                    <td style="padding-right:10px; padding-left:10px;">
                        <div *ngIf="impersonateByUserId <= 0" [attr.title]="'User' | translate"
                            [matMenuTriggerFor]="userMenu"
                            style="width:23px; height:23px; background-color:white; text-align:center; border-radius:50%; -webkit-border-radius: 50%; -moz-border-radius:50%; cursor:pointer;">
                            <span class="robotoMedium"
                                style="position:relative; top:2px; color:#3f51b5; font-size:11px;">
                                {{userInitials}}
                            </span>
                        </div>
                        <div *ngIf="impersonateByUserId > 0" class="sis-header-impersonatinguser"
                            [attr.title]="'User' | translate" [matMenuTriggerFor]="userMenu" style="cursor:pointer;">
                        </div>
                        <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
                            <button mat-menu-item [matMenuTriggerFor]="languages" *ngIf="userService.userType != 1">
                                <span translate>Select Language</span>
                            </button>
                            <button mat-menu-item (click)="setNotificationPreferencesClick()"
                                *ngIf="showNotificationPreferencesLink">
                                <span translate>Set Notification Preferences</span>
                            </button>
                            <button mat-menu-item (click)="changeEmailAddressClick()"
                                *ngIf="LoginSettings.DisplayChangeEmailAddress && userService.userType == 2">
                                <span translate>Change Email Address</span>
                            </button>
                            <button mat-menu-item (click)="changePasswordClick()" *ngIf="showChangePassword">
                                <span translate>Change Password</span>
                            </button>
                            <button mat-menu-item (click)="mealServiceClick()"
                                *ngIf="!LoginSettings.V10 && LoginSettings.ActivateClassroom360 && userService.userType == 1">
                                <span translate>Meal Service</span>
                            </button>
                            <button mat-menu-item (click)="userPreferencesClick()"
                                *ngIf="userService.userType == 1 && LoginSettings.ActivateClassroom360">
                                <span transalte>Preferences</span>
                            </button>
                            <button mat-menu-item (click)="teacherProfileClick()"
                                *ngIf="showTeacherProfile == true && LoginSettings.ActivateClassroom360">
                                <span translate>Teacher Profile</span>
                            </button>
                            <mat-divider></mat-divider>
                            <button mat-menu-item (click)="logoutUser()">
                                <span *ngIf="!userLoginFromLegacy && !stopImpersonating" translate>Logout</span>
                                <span *ngIf="userLoginFromLegacy && !stopImpersonating" translate>Logout of 360</span>
                                <span translate *ngIf="stopImpersonating">Stop Impersonating</span>
                            </button>
                        </mat-menu>
                       

                        <mat-menu #languages="matMenu">
                            <button mat-menu-item (click)="languageClick('en')" translate>English</button>
                            <button mat-menu-item (click)="languageClick('fr')" translate>French</button>
                            <button mat-menu-item (click)="languageClick('pt')" translate>Portuguese</button>
                            <button mat-menu-item (click)="languageClick('es')" translate>Spanish</button>
                        </mat-menu>
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <div *ngIf="!isLoggedIn || !isPageLoaded">
        <div class="sis-app-tylersis-title" style="display:table-cell;height:53px;padding-left:25px;">Tyler SIS</div>
    </div>

    <div *ngIf="(userService.userType == 1 || !isLoggedIn) && LoginSettings.InstanceName.length > 0"
        style="text-align:center;background-color:#e5b53a;">
        {{LoginSettings.InstanceName}}
    </div>
</div>

<form #form target="_blank" action="https://doc360.sisk12.com/tylersis360doc.asp" method="post">
    <input type="hidden" name="id" [value]="helpContextId">
    <button id="buttonHelp" type="submit" (click)="form.submit()" style="display:none;" translate>Submit</button>
</form>